<template>
    <template v-if="displayBreadCrumb">
        <div class="gibs-breadcrumb-body">
            <div id="gibs-breadcrumb" class="gibs-breadcrumb">
                <template v-for="step in breadCrumbSteps">
                    <div class="gibs-breadcrumb-step-wrapper">
                        <NuxtLink :to="breadcrumbStepNavigate(step.URL)" class="gibs-breadcrumb-step">
                            {{ step.Name }}
                        </NuxtLink>
                        <NuxtIcon class="gibs-breadcrumb-forward-icon" name="buttons/forward-arrow" />
                    </div>
                </template>
            </div>
        </div>
    </template>
    <!-- Breadcrumb is hidden on homepage -->
    <template v-else-if="(!displayBreadCrumb && breadCrumbSteps.length === 1) && (breadCrumbSteps[0].URL !== path)">
        <div class="w-full h-7.5"></div>
    </template>
</template>

<script setup lang="ts">
    import { z } from 'zod';
    import { breadcrumbStepNavigate} from '~/utils/url';

    const props = defineProps({
        fullPath: {
            type: String,
            default: "/"
        }
    });

    const displayBreadCrumb = ref<boolean>(false);
    const path = ref<string>(props.fullPath.toLowerCase());
    const breadCrumbSteps = ref<Array<ISiteMapEntry>>([]);

    

    function setupDisplayBreadCrumbElement() {
        displayBreadCrumb.value = breadCrumbSteps.value.length === 1? false : true;
    }


    function createBreadcrumbSteps(siteMapEntry:ISiteMapEntry): Array<ISiteMapEntry> {
        let breadCrumbSteps = [];

        if (siteMapEntry != null && siteMapEntry != 'null') {
                siteMapEntry.Pages.forEach((entry:  z.infer<typeof SiteMapItemSchema>) => {
                    breadCrumbSteps.push(entry);
                });
                breadCrumbSteps.push(siteMapEntry);
        }
        return breadCrumbSteps;
    }


    onMounted(async() => {

        breadCrumbSteps.value = [];
        const sitemapJson = retrieveSitemapData();

        if (sitemapJson != null) {
            const siteMap =  new SiteMap(sitemapJson)
            await siteMap.init(sitemapJson);
            var p = await aliassesCheck(props.fullPath);
            // debugger;
            const  siteMapEntry: ISiteMapEntry = siteMap.getEntryByUrl(p);
            //const  siteMapEntry: ISiteMapEntry = siteMap.getEntryByUrl(props.fullPath);

            siteMapEntry.PagePath = await aliassesRevert(siteMapEntry.PagePath);
            //siteMapEntry.PagePath = (siteMapEntry.PagePath);

            breadCrumbSteps.value = createBreadcrumbSteps(siteMapEntry);
        }
      
        setupDisplayBreadCrumbElement();
    })

    watch(() => props.fullPath, async newPath => {

        const sitemapJson = retrieveSitemapData();

        if (sitemapJson != null) {
            const siteMap =  new SiteMap(sitemapJson);
            await siteMap.init(sitemapJson);
            var p = await aliassesCheck(props.fullPath);
            const  siteMapEntry: ISiteMapEntry = siteMap.getEntryByUrl(p);
            //const  siteMapEntry: ISiteMapEntry = siteMap.getEntryByUrl(props.fullPath);

            siteMapEntry.PagePath = await aliassesRevert(siteMapEntry.PagePath);
            //siteMapEntry.PagePath = (siteMapEntry.PagePath);

            breadCrumbSteps.value = createBreadcrumbSteps(siteMapEntry);
        }

        setupDisplayBreadCrumbElement();
    });
    async function aliassesCheck(blobPath:string):string{
     
        var Aliasses =  JSON.parse(JSON.stringify(await fetchJsonDataOverride('aliasses.json')));
                //http://localhost:3000/programmes/online-Professional%20Development%20Courses--effective-change-management--preparing-yourself-and-your-team
            blobPath = blobPath.replace(/%20/g, ' '); //replace %20 with space
            // if(
            //     (blobPath.indexOf('programmes')>=0) &&
            //     (blobPath.indexOf(' ')>=0)  //assuming that the space will be in the aliasses. 
            // ){
             
            //     var blobStr = blobPath;
            //     const keys = Object.keys(Aliasses);
            //     for (let i = keys.length - 1; i >= 0; i--) {
            //         const key = keys[i];
            //         if(blobStr.indexOf(Aliasses[key])>=0){
            //             blobStr = blobStr.replace(new RegExp(Aliasses[key], 'g'),key );
            //         }
            //     }
            //     blobPath = blobStr.toLowerCase();
            // }

            return blobPath;

    }
    async function aliassesRevert(blobPath:string):string{
     
        var Aliasses =  JSON.parse(JSON.stringify(await fetchJsonDataOverride('aliasses.json')));
                //http://localhost:3000/programmes/online-Professional%20Development%20Courses--effective-change-management--preparing-yourself-and-your-team
            blobPath = blobPath.replace(/%20/g, ' '); //replace %20 with space
            if(
                (blobPath.indexOf('programmes')>=0) &&
                (blobPath.indexOf(' ')>=0)  //assuming that the space will be in the aliasses. 
            ){
          
                var blobStr = blobPath;
                const keys = Object.keys(Aliasses);
                for (let i = keys.length - 1; i >= 0; i--) {
                    const key = keys[i];
                    if(blobStr.indexOf(Aliasses[key])>=0){
                        blobStr = blobStr.replace(new RegExp(Aliasses[key], 'g'),key );
                    }
                }
                blobPath = blobStr.toLowerCase();
            }

            return blobPath;

    }
</script>